import { Loader2 } from "lucide-react";
import type { FC } from "react";

import { cn } from "@/lib/utils";
import { Avatar, AvatarFallback, AvatarImage } from "@recobra/ui/avatar";

import { getInitials } from "./user-display-name";

/** Avatar + name, for showing who did/owns something (assignee, author, etc.). */
export const UserAvatarLabel: FC<{
  name: string;
  picture?: string;
  className?: string;
  /** `xs` for dense one-line contexts. */
  size?: "sm" | "xs";
  /** Shows a spinner in place of the avatar, e.g. while a change is saving. */
  isBusy?: boolean;
}> = ({ name, picture, size = "sm", className, isBusy }) => (
  <div className={cn("flex min-w-0 items-center gap-2", className)}>
    {isBusy ? (
      <Loader2 className="size-6 shrink-0 animate-spin text-muted-foreground" />
    ) : (
      <Avatar size="sm" className="shrink-0">
        {picture ? <AvatarImage src={picture} alt={name} /> : null}
        <AvatarFallback>{getInitials(name)}</AvatarFallback>
      </Avatar>
    )}
    <span className={size === "xs" ? "truncate text-xs" : "truncate text-sm"}>{name}</span>
  </div>
);
